import { Box, Divider } from '@achieve/ascend'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { ANCHOR_POINTS, AchieveBadge } from 'components/AchieveBadge'
import { CarouselV2 } from 'components/Carousels/CarouselV2'

const CardSkinnyCarousel = ({ item }) => {
  return (
    <>
      {item?.cardBadgeImage && (
        <AchieveBadge
          content={item?.cardBadgeImage}
          height={80}
          width={70}
          anchor={ANCHOR_POINTS.RIGHT_TOP}
          translateX={-60}
          translateY={-8}
        />
      )}
      <Box
        className={
          'bg-white min-w-[320px] max-w-full border flex flex-col gap-4 px-4 py-8 rounded-md border-solid border-neutral-150 lg:max-w-[320px]'
        }
      >
        <Box>
          <Typography
            content={item?.cardTitleText}
            className={'text-neutral-900'}
            variant="bodySm"
            fontWeight="bold"
          />
          <Divider className={'my-1 mx-0'} />
          {item?.cardSubtitleText && (
            <Typography
              content={item?.cardSubtitleText}
              className={'text-neutral-500'}
              variant="bodyXs"
              fontWeight="regular"
            />
          )}
        </Box>
        <Box>
          <Box className={'flex flex-row gap-1 justify-center'}>
            <Box className={'flex flex-col text-center justify-end max-w-[100px]'}>
              <Typography
                content={item?.cardJson?.graph?.[0]?.valueText}
                className={''}
                variant="bodyXs"
                fontWeight="regular"
              />
              <Box className={'h-[70px] w-[100px] rounded-[8px_8px_0_0] bg-blue-100'}></Box>
            </Box>
            <Box className={'flex flex-col text-center justify-end max-w-[100px]'}>
              <Typography
                content={item?.cardJson?.graph?.[1]?.valueText}
                className={''}
                variant="bodyXs"
                fontWeight="regular"
              />
              <Box
                className={
                  '[background:linear-gradient(180.09deg,#30f_-19.14%,#68d6f2_121.73%)] h-[47px] w-[100px] rounded-[8px_8px_0_0] data-[graph="card2"]:h-7 data-[graph="card3"]:h-[57px]'
                }
                data-graph={item?.fieldName}
              />
            </Box>
          </Box>
          <Box className={'flex flex-row justify-center text-center'}>
            <Typography
              content={item?.cardJson?.graph?.[0]?.legendText}
              className={'text-neutral-300 w-[100px] min-h-[45px] px-1 py-0'}
              variant="bodyXs"
              fontWeight="regular"
            />

            <Typography
              content={item?.cardJson?.graph?.[1]?.legendText}
              className={'text-neutral-300 w-[100px] min-h-[45px] px-1 py-0'}
              variant="bodyXs"
              fontWeight="regular"
            />
          </Box>
        </Box>
        <Box
          className={'bg-[#eff5ff] flex flex-row gap-2 items-center px-3 py-2 rounded-md'}
          data-variant={item?.cardJson?.markerVariant}
        >
          <Box
            className={
              'min-w-[53px] max-w-[53px] max-h-[53px] data-[variant="awards"]:min-w-[24px] data-[variant="awards"]:max-w-[24px] data-[variant="awards"]:max-h-[50px] data-[variant="awards"]:first-of-type:mr-5'
            }
            data-variant={item?.cardJson?.markerVariant}
          >
            <MediaImageStandard
              alt={item?.cardImage?.fields?.title}
              content={item?.cardImage}
              layout="responsive"
            />
          </Box>
          <Typography
            content={item?.cardText}
            className={''}
            variant="bodyXs"
            fontWeight="regular"
          />
          {item?.cardImageAlternative && (
            <Box
              className={
                'min-w-[53px] max-w-[53px] max-h-[53px] data-[variant="awards"]:min-w-[24px] data-[variant="awards"]:max-w-[24px] data-[variant="awards"]:max-h-[50px] data-[variant="awards"]:first-of-type:mr-5'
              }
              data-variant={item?.cardJson?.markerVariant}
            >
              <MediaImageStandard
                alt={item?.cardImageAlternative?.fields?.title}
                content={item?.cardImageAlternative}
                layout="responsive"
              />
            </Box>
          )}
        </Box>
        {item?.cardJson?.helpText && (
          <Typography
            content={item?.cardJson?.helpText}
            className={'text-neutral-300 italic'}
            variant="bodyXs"
            fontWeight="regular"
          />
        )}
      </Box>
    </>
  )
}

const PaperCarouselCards = ({ gridItems, trackingNameCarouselControls }) => {
  return (
    <CarouselV2
      gridItems={gridItems}
      ItemComponentCarousel={CardSkinnyCarousel}
      variant="cards"
      trackingNameCarouselControls={trackingNameCarouselControls}
    />
  )
}

export { CardSkinnyCarousel, PaperCarouselCards }
